import React from "react";

import WPHeading from "../../../../packages/WPHeading";

const LicenseDetailCellRenderer = ({ value, className, colId, node }) => {
  const actualRowIndex = node?.rowIndex;
  if (!value) return null;
  return (
    <WPHeading
      size="small"
      type="default"
      text={value}
      tooltip={value}
      secondary
      className={className}
      id={`license-cell-${colId}-row-${actualRowIndex}`}
    />
  );
};

export default LicenseDetailCellRenderer;
